export default (state) => state.uploads;
